import GenericCell, { GenericCellProps } from '@components/design/migrated/Table/GenericCell';
import { ProductsCellClassType } from '@models/Products';
import { formatFirstActivity } from '@utils/PeriodUtils';
import ProductsTableGenericCell from '../products-table-generic-cell/ProductsTableGenericCell';

type Props = {
  firstActivityDate: string;
  cellAlignment: GenericCellProps['alignment'];
};

const ProductsTableFirstActivityCell: React.FC<Props> = ({ firstActivityDate, cellAlignment }) => {
  const formattedFirstActivityDate: string = firstActivityDate ? formatFirstActivity(firstActivityDate) : '';
  return (
    <ProductsTableGenericCell classType={ProductsCellClassType.FEATURE}>
      <GenericCell alignment={cellAlignment} primary={formattedFirstActivityDate} />
    </ProductsTableGenericCell>
  );
};

export default ProductsTableFirstActivityCell;
